import styled from "styled-components";

export const FormWrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding-top: 20px;
  gap:20px;
  width: 100%;
`